<template>
  <div class="rereadUpImg">
    <div class="uploadImgBox">
      <van-image
        class="listImg"
        v-for="(item, index) in fileList"
        :key="index"
        :src="item"
        fit="cover"
        @click="previewImage(index)"
      >
        <img
          class="closeIcon"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/del.png"
          alt="close"
          @click.stop="delImage(index)"
        />
      </van-image>
      <template v-if="$root.isApp">
        <div class="cameraBox" @click="arouse" v-show="fileList.length < maxNum">
          <div>
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/Takepictures.png"
              alt=""
            />
            <span>上传图片</span>
          </div>
        </div>
      </template>
      <template v-else>
        <van-uploader
          v-show="fileList.length < maxNum"
          :after-read="afterRead"
          :accept='image'
          :preview-image="false"
        >
          <div class="cameraBox">
            <div v-if="loading">
              <van-loading size="24px" vertical>图片上传中...</van-loading>
            </div>
            <div v-else>
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/Takepictures.png"
                alt=""
              />
              <span>上传图片</span>
            </div>
          </div>
        </van-uploader>
      </template>
    </div>

    <van-image-preview
      v-model="isShowPreview"
      :images="fileList"
      :startPosition="startPosition"
      get-container="body"
    />

    <van-image-preview
      v-model="isShowExamplePreview"
      :images="defaultExampleList"
      startPosition="0"
      get-container="body"
    />
  </div>
</template>

<script>
import { isOhos } from '@/utils/common';

export default {
  components: {},
  props: {
    maxNum: {
      type: Number,
      default: 20,
    },
    ImgList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    ImgList(val) {
      if (!val.length) {
        this.fileList = [];
      }
    },
  },
  data() {
    return {
      isShowPreview: false, // 是否开启预览
      startPosition: 0, // 预览索引
      isShowExamplePreview: false,
      defaultExampleList: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BC%96%E7%BB%84%2018%402x.png`,
      ],
      loading: false,
      fileList: [],
    };
  },
  methods: {
    arouse() {
      if (this.$root.$data.isApp) {
        window.uploaderFiles = (value) => {
          const data = isOhos ? value : JSON.parse(value);
          if (data.success !== 1) {
            this.$toast.fail('上传失败');
          } else {
            this.fileList = [...this.fileList, ...data.images];
            this.$emit('getListFile', this.fileList);
          }
        };
        this.$sendToApp('arouseImagePicker', { pickNum: 1 });
      }
    },
    previewImage(index) {
      // 图片预览
      this.isShowPreview = true;
      this.startPosition = index;
    },
    delImage(index) {
      // 删除图片
      this.fileList.splice(index, 1);
      this.$emit('deleteFile', index);
    },

    afterRead(file) {
      console.log(file, 888);
      this.fileList.push(file.content);
      this.$emit('getListFile', file.file);
    },
  },
};
</script>

<style scoped lang="scss">
.rereadUpImg {
  .uploadImgBox {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    width: 100%;
    .cameraBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 187px;
      height: 187px;
      text-align: center;
      background: #f5f6f7;
      border-radius: 14px;
      img {
        width: 56px;
        height: 45px;
      }
      span {
        display: block;
        color: #666;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
      }
    }
    .listImg {
      position: relative;
      width: 187px;
      height: 187px;
      ::v-deep .van-image__img {
        border-radius: 14px;
      }
      .closeIcon {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 29px;
        height: 29px;
      }
    }
  }
}
</style>
